import MyDropzone from './MyDropzone';

export { Props } from './MyDropzone';
export default MyDropzone;
